import React, {useEffect} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
} from 'reactstrap';

import {
    LIST,
    NO_DATA_FOUND,
} from "../../../components/i18n/i18n";

import {TT_DELETE,  TT_EDIT} from "../../../components/i18n/toolTips";

import TableAdapter from '../../../components/TableAdapter/TableAdapter';
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import ProgramFilters from "./_filters";
import {getStateByPath} from "../../../redux/selectors";
import {setFilter, setTableParams, setForm, setItem, setLoading} from "../../../redux/actions/generics/IndexedActions";
import {connect, useSelector} from "react-redux";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import ProgramForm from "./_form";
import {GenericButton} from "../../../components/buttons/customButtons";
import {setViewMode} from "../../../redux/actions/genericActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {programService} from "../../../jwt/_services/clasificator/programService";

const ProgramList = (props) => {
    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const { app, udn, pageSize, pageIndex, totalSize, listDomainObjects, filter } = componentState?.data || {};
    const fbDataBaseId = app?.fbDataBase?.id

    useEffect( () => {
        if(filter || !app?.id)
            return

        props.setFilter(path, {
            fbDataBase : { id: app?.fbDataBase?.id},
            item: {
                udn: { id : udn?.id }
            }
        })
    }, [app]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, programService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams(path, tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => {
        return ConfirmDelete({
            path,
            data,
            fbDataBaseId : fbDataBaseId,
            service: programService,
            remove : genericIndexedActions.delete
        });
    };

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path)

        ModalFormContainer(ProgramForm, { path })
    }


    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(ProgramForm, { path, data, closeOnEscape:false, closeOnClickOutside: false})
    }

    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
                <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
            </div>
        );
    }

    const columns = [{
        dataField: 'id',
        text: 'ID',
        headerStyle: {width: '0px'},
        hidden: true
    }, {
        dataField: 'uid',
        text: 'uid',
        headerStyle: {width: '200px'},
    }, {
        dataField: 'title',
        text: 'Titulo'
    }, {
        dataField: 'showOrder',
        headerStyle: {width: '50px'},
        text: "Orden de presentación"
    }, {
        dataField: 'status',
        headerStyle: {width: '50px'},
        text: "Activo",
        formatter: activeFormatter
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '180px'},
        formatter: actionsFormatter
    }
    ];

    return (
        <div>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"/>{LIST}
                    <div className="float-right">
                        <GenericButton
                            style={'table'}
                            label={'Agregar'}
                            toolTip={'Agregar'}
                            icon={'fa-plus'}
                            permission={'add'}
                            onClick={createItem}
                        />
                    </div>
                </CardTitle>

                <ProgramFilters path={path} />

                <CardBody className="">
                    <TableAdapter
                        striped hover
                        tableHeaderClass='mb-0'
                        keyField="id"
                        data={listDomainObjects || []}
                        columns={columns}
                        remote
                        pagination={{ pageIndex, pageSize, totalSize }}
                        onTableChange={handleTableChange}
                        noDataIndication={NO_DATA_FOUND}
                    />
                </CardBody>
            </Card>
        </div>
    )
}

const mapStateToProps = _ => ({})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
})
export default connect(mapStateToProps, mapActionsToProps)(ProgramList)
